export const DL_CARGOS = 'cargos';
export const DL_CARGOS_LIST = 'list';
export const DL_CARGOS_DETAILS = 'details';
export const DL_CARGOS_RESUBMIT = 'resubmit';